import { checkTodayInRange } from './checkTodayInRange';

export const MAY_DELIVERY_NOTICE_IMAGE_URL =
  'https://cdn.welfarehello.com/static/donation/delivery-notice-may.png';

const MAY_DELIVERY_NOTICE_START_AT = '2026-04-28 00:00:00';
const MAY_DELIVERY_NOTICE_END_AT = '2026-05-06 23:59:59';

export const shouldShowMayDeliveryNoticeImage = () =>
  checkTodayInRange(MAY_DELIVERY_NOTICE_START_AT, MAY_DELIVERY_NOTICE_END_AT);
